import { createSlice } from "@reduxjs/toolkit";

// Draft state for the multi-step CreateOfferingPage form.
// Persisted automatically (see index.js persistConfig has no whitelist),
// so a refresh mid-form keeps the user's progress.
const initialState = {
  activeStep: 0,
  letterOpening: "",
  letterClosing1: "",
  letterClosing2: "",
  expandedCosts: {},
  info: {
    title: "",
    offeringNumber: "",
    workingUnit: "",
    signingOfficial: "",
    mitraId: "",
    prospectName: "",
    prospectEmail: "",
    prospectPhone: "",
    offer_date: "",
    offer_period: "",
    validUntil: "",
    startDate: "",
    endDate: "",
    revenueType: "REGULAR",
  },
  infoErr: {},
  selectedService: "",
  selectedUnits: [],
  filterProperty: "",
  filterBuilding: "",
  filterFloor: "",
  periods: [{ label: "", periodStart: "", periodEnd: "", costs: [] }],
  revenueForm: {
    type: "REGULAR",
    shareBasis: "GROSS_SALES",
    revenueShareMethod: "",
    flatRate: { isActive: false, ratePercent: "" },
    mgp: { isActive: false, mgpAmount: "", mgpRatePercent: "" },
    yearlyRates: [],
    conditionalRate: { tiers: [] },
    tieredScheme: { tiers: [] },
    salesBracket: {
      lowRate: 7,
      threshold: 100000000,
      highRate: 10,
      maxRevShare: 10000000,
    },
    settlementSchedule: {
      frequency: "monthly",
      daily: { hour: "08" },
      weekly: { day: "1" },
      monthly: { date: "1" },
      bimonthly: { monthOffset: 1, date: "1" },
      quarterly: { monthOffset: 1, date: "1" },
      fourmonthly: { monthOffset: 1, date: "1" },
      semester: { monthOffset: 1, date: "1" },
      yearly: { date: "" },
      billingConfig: {
        billingOffsetDays: 0,
        dueOffsetDays: 14,
      },
    },
  },
};

const createOfferingFormSlice = createSlice({
  name: "createOfferingForm",
  initialState,
  reducers: {
    setField: (state, action) => {
      state[action.payload.key] = action.payload.value;
    },
    resetForm: () => initialState,
  },
});

export const createOfferingFormAction = createOfferingFormSlice.actions;

export function selectCreateOfferingForm(state) {
  return state?.createOfferingForm ?? initialState;
}

export default createOfferingFormSlice.reducer;
